import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import './About.css';
import Tabs from '../../components/Tabs';
import AboutUs from '../../components/AboutUs';
// import AboutCompany from '../../components/AboutCompany';
import AboutStihl from '../../components/AboutStihl';
import Breadcrumb from '../../components/Breadcrumb';
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount';

const About = (props) => {
  const { match } = props;
  const tabs = [
    { title: '關於我們', link: '/about/us', stateIdentifier: 'us' },
    { title: '關於STIHL', link: '/about/stihl', stateIdentifier: 'stihl' },
  ];
  return (
    <section className="section">
      <ScrollToTopOnMount />
      <div className="about container">
        <Breadcrumb {...props} />
        <Tabs tabs={tabs} {...props} />
        <div className="outter-container">
          {match.params.filter === 'us' && <AboutUs />}
          {match.params.filter === 'stihl' && <AboutStihl />}
          {match.params.filter !== 'us' &&
            match.params.filter !== 'stihl' && <Redirect to="/about/us" />}
        </div>
      </div>
    </section>
  );
};

About.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      aboutpage: PropTypes.string,
    }),
  }),
};

About.defaultProps = {
  match: {
    params: {
      aboutpage: 'us',
    },
  },
};

export default About;



// WEBPACK FOOTER //
// ./src/containers/page/About.js